function Footer({ children }) {
  return <div>{children}</div>;
}

export default Footer;
